import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

// dummy commit
const store = configureStore({
  reducer: rootReducer,
});

export default store;
